import CryptoJS from 'crypto-js';

export function getQueryString() {
    const url = location.href;
    if (!url.includes("?")) return null;
    let temp1 = url.split("?");
    let param = temp1[1];
    let keyValue = param.split("&");
    let obj = {};
    for (let i = 0; i < keyValue.length; i++) {
        let item = keyValue[i].split("=");
        let key = item[0];
        let value = item[1];
        obj[key] = value;
    }
    return obj;
}

/* 获取URl参数中的v */
export function getQueryBase64() {
    const params = new URLSearchParams(window.location.search);
    // const name = params.get('name'); // 获取单个参数
    // const hasAge = params.has('age'); // 检查参数是否存在

    // 遍历所有参数
    let obj = {};
    for (const [key, value] of params.entries()) {
        obj[key] = value;
    }
    // console.log(obj, 'obj')
    return obj;
}

// base64解码url参数v
export function decodeUrlParams() {
    // {
    //     "puid": "sg_SDEGAGRGH",  // puid
    //     "sid": 650,  // serverid
    //     "sn": "天下纷争",  // servername
    //     "pid": 10543,     // playerid
    //     "pn": "King",     // playername
    //     "aid": 35,        // 头像id
    //     "le": 10,        // 等级
    //     "did": "c4games_s_79a651d60763bd18", // 唯一标识
    //     "gid": 13,  // gameid
    //     "sign": "24435414d6c6a6c444e675a35413d3d"
    //     "jump": 1 // 1为跳到浏览器访问
    // }
    const urlParams = new URLSearchParams(window.location.search);
    const URL_V = urlParams.get("v") || "";
    const getV = URL_V || window.localStorage.getItem("v") || "";
    const { v } = getQueryBase64() || (getV ? { v: getV } : {});
    try {
        if (v) {
            let params = v.replace(/\s/g, '+'); // 特殊处理了一下+号，+号会被浏览器解析为空格
            let decodeP = CryptoJS.enc.Base64.parse(params);
            const parsedStr = decodeP.toString(CryptoJS.enc.Utf8).replace(/\s/g, ''); // 移除解析结果中的所有空格
            return JSON.parse(parsedStr)
        } else {
            return {}
        }

    } catch (e) {
        try {
            let params = v.replace(/\s/g, '+'); // 特殊处理了一下+号，+号会被浏览器解析为空格
            let decodeP = CryptoJS.enc.Base64.parse(params);
            const parsedStr = decodeP.toString(CryptoJS.enc.Utf8).replace(/\s/g, ''); // 移除解析结果中的所有空格
            // 保留JSON语法允许的字符（{}、""、:、,、数字、字母、中文等）
            const cleanedStr = parsedStr.replace(/[^\x20-\x7E\u4e00-\u9fa5]/g, '');
            const jsonObj = JSON.parse(cleanedStr) || {};
            return jsonObj
        } catch (error) {
            return {}
        }
    }
}

// export function decodeSpecialUsd() {
//     const { usd } = getQueryString() || {};
//     // {
//     //     "puid": "sg_SDEGAGRGH",  // puid
//     //     "sid": 650,  // serverid
//     //     "sn": "天下纷争",  // servername
//     // }
//     try {
//         if (usd) {
//             let params = usd.replace(/\s/g, '+'); // 特殊处理了一下+号
//             let decodeP = CryptoJS.enc.Base64.parse(params);
//             const parsedStr = decodeP.toString(CryptoJS.enc.Utf8);
//             // console.log(JSON.parse(parsedStr), 'json')
//             return JSON.parse(parsedStr)
//         } else {
//             return {}
//         }

//     } catch (e) {
//         console.log(e, 'e')
//         return {}
//     }
// }

// 防抖
export function _debounce(fn, delay = 200) {
    var timer = null;
    return function () {
        var _this = this;
        var args = arguments;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(_this, args);
        }, delay);
    };
}
